import { render, staticRenderFns } from "./SystemInformation.vue?vue&type=template&id=5120ce84&scoped=true"
import script from "./SystemInformation.vue?vue&type=script&lang=js"
export * from "./SystemInformation.vue?vue&type=script&lang=js"
import style0 from "./SystemInformation.vue?vue&type=style&index=0&id=5120ce84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5120ce84",
  null
  
)

export default component.exports